export default __webpack_public_path__ + "static/media/not-visible-icon.a069a241.svg";